import { render, staticRenderFns } from "./zuoyechaxun.vue?vue&type=template&id=5ccea204&scoped=true&"
import script from "./zuoyechaxun.vue?vue&type=script&lang=js&"
export * from "./zuoyechaxun.vue?vue&type=script&lang=js&"
import style0 from "./zuoyechaxun.vue?vue&type=style&index=0&id=5ccea204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccea204",
  null
  
)

export default component.exports